let obj = {};
obj.guarantPre = [
  {
    key: '1',
    value: '1个月'
  },
  {
    key: '2',
    value: '2个月'
  },
  {
    key: '3',
    value: '3个月'
  },
  {
    key: '4',
    value: '4个月'
  },
  {
    key: '5',
    value: '5个月'
  },
  {
    key: '6',
    value: '6个月'
  },
  {
    key: '7',
    value: '7个月'
  },
  {
    key: '8',
    value: '8个月'
  },
  {
    key: '9',
    value: '9个月'
  },
  {
    key: '10',
    value: '10个月'
  },
  {
    key: '11',
    value: '11个月'
  },
  {
    key: '12',
    value: '12个月'
  }
];
obj.companyIdTypeOptions = [
  {
    value: '04',
    name: '统一社会信用代码'
  }
];
obj.companyPropertyList = [
  {
    value: '01',
    text: '国家机关'
  },
  {
    value: '02',
    text: '国有事业单位'
  },
  {
    value: '03',
    text: '国有企业'
  },
  {
    value: '06',
    text: '上市公司'
  },
  {
    value: '99',
    text: '其它'
  }
];
obj.cunxuTimeList = [
  {
    value: '2',
    text: '3年以下'
  },
  {
    value: '3',
    text: '3年及以上'
  }
];
obj.KZSCOptions = [
  {
    value: -1,
    name: '不附加'
  },
  {
    value: 0,
    name: '附加'
  }
];
obj.YWZYJTOptions = [
  {
    value: 100,
    name: '100/天'
  }
];
obj.YWZBOptions = [
  {
    value: 2000,
    name: '2000/周'
  },
  {
    value: 3000,
    name: '3000/周'
  }
];
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
    value: '3',
    name: '3类'
  },
  {
    value: '4',
    name: '4类'
  },
  {
    value: '5',
    name: '5类'
  },
  {
    value: '6',
    name: '6类'
  }
];
obj.IdTypeOptions = [
  {
    value: '1',
    name: '身份证'
  }
];
obj.sexOptions = [
  {
    value: 'M',
    name: '男'
  },
  {
    value: 'F',
    name: '女'
  }
];
obj.plansValues = [
  {
    name: '计划一',
    value: 'XSAIGHSB2022C01',
    optionSelect: {
      YWSGSC: 100000, //意外身故及伤残保障
      YWYYBT: 10000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 2000, //意外/疾病重症监护病房住院津贴
      CS: 100000, //猝死
      YWSGSZXE: 10000, //意外身故丧葬费用限额
      MYHKYWSC: 500000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 300000, //轮船意外身故及伤残保障
      GDSCBZ: 300000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 200000, //公共汽车意外身故及伤残保障
      JCSJGS: 100000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划二',
    value: 'XSAIGHSB2022C02',
    optionSelect: {
      YWSGSC: 200000, //意外身故及伤残保障
      YWYYBT: 20000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 2000, //意外/疾病重症监护病房住院津贴
      CS: 100000, //猝死
      YWSGSZXE: 10000, //意外身故丧葬费用限额
      MYHKYWSC: 500000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 300000, //轮船意外身故及伤残保障
      GDSCBZ: 300000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 200000, //公共汽车意外身故及伤残保障
      JCSJGS: 100000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划三',
    value: 'XSAIGHSB2022C03',
    optionSelect: {
      YWSGSC: 300000, //意外身故及伤残保障
      YWYYBT: 30000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 2000, //意外/疾病重症监护病房住院津贴
      CS: 100000, //猝死
      YWSGSZXE: 20000, //意外身故丧葬费用限额
      MYHKYWSC: 1000000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 600000, //轮船意外身故及伤残保障
      GDSCBZ: 600000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 400000, //公共汽车意外身故及伤残保障
      JCSJGS: 200000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划四',
    value: 'XSAIGHSB2022C04',
    optionSelect: {
      YWSGSC: 400000, //意外身故及伤残保障
      YWYYBT: 40000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 2000, //意外/疾病重症监护病房住院津贴
      CS: 100000, //猝死
      YWSGSZXE: 20000, //意外身故丧葬费用限额
      MYHKYWSC: 1000000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 600000, //轮船意外身故及伤残保障
      GDSCBZ: 600000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 400000, //公共汽车意外身故及伤残保障
      JCSJGS: 200000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划五',
    value: 'XSAIGHSB2022C05',
    optionSelect: {
      YWSGSC: 500000, //意外身故及伤残保障
      YWYYBT: 50000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 2000, //意外/疾病重症监护病房住院津贴
      CS: 100000, //猝死
      YWSGSZXE: 30000, //意外身故丧葬费用限额
      MYHKYWSC: 1500000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 900000, //轮船意外身故及伤残保障
      GDSCBZ: 900000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 600000, //公共汽车意外身故及伤残保障
      JCSJGS: 300000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划六',
    value: 'XSAIGHSB2022C06',
    optionSelect: {
      YWSGSC: 600000, //意外身故及伤残保障
      YWYYBT: 60000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 3000, //意外/疾病重症监护病房住院津贴
      CS: 200000, //猝死
      YWSGSZXE: 30000, //意外身故丧葬费用限额
      MYHKYWSC: 1500000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 900000, //轮船意外身故及伤残保障
      GDSCBZ: 900000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 600000, //公共汽车意外身故及伤残保障
      JCSJGS: 300000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划七',
    value: 'XSAIGHSB2022C07',
    optionSelect: {
      YWSGSC: 700000, //意外身故及伤残保障
      YWYYBT: 70000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 3000, //意外/疾病重症监护病房住院津贴
      CS: 200000, //猝死
      YWSGSZXE: 30000, //意外身故丧葬费用限额
      MYHKYWSC: 2000000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 1200000, //轮船意外身故及伤残保障
      GDSCBZ: 1200000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 800000, //公共汽车意外身故及伤残保障
      JCSJGS: 400000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划八',
    value: 'XSAIGHSB2022C08',
    optionSelect: {
      YWSGSC: 800000, //意外身故及伤残保障
      YWYYBT: 80000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 3000, //意外/疾病重症监护病房住院津贴
      CS: 200000, //猝死
      YWSGSZXE: 40000, //意外身故丧葬费用限额
      MYHKYWSC: 2000000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 1200000, //轮船意外身故及伤残保障
      GDSCBZ: 1200000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 800000, //公共汽车意外身故及伤残保障
      JCSJGS: 400000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划九',
    value: 'XSAIGHSB2022C09',
    optionSelect: {
      YWSGSC: 900000, //意外身故及伤残保障
      YWYYBT: 90000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 3000, //意外/疾病重症监护病房住院津贴
      CS: 200000, //猝死
      YWSGSZXE: 40000, //意外身故丧葬费用限额
      MYHKYWSC: 2500000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 1500000, //轮船意外身故及伤残保障
      GDSCBZ: 1500000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 1000000, //公共汽车意外身故及伤残保障
      JCSJGS: 500000 //私家车和公司班车意外身故及伤残保障
    }
  },
  {
    name: '计划十',
    value: 'XSAIGHSB2022C10',
    optionSelect: {
      YWSGSC: 1000000, //意外身故及伤残保障
      YWYYBT: 100000, //意外医药补贴
      YWMRJT: 100, //意外每日住院津贴
      YWJBZZJHJT: 3000, //意外/疾病重症监护病房住院津贴
      CS: 200000, //猝死
      YWSGSZXE: 40000, //意外身故丧葬费用限额
      MYHKYWSC: 2500000, //民用航空飞机意外身故及伤残保障
      KYGDJLC: 1500000, //轮船意外身故及伤残保障
      GDSCBZ: 1500000, //轨道交通工具意外身故及伤残保障
      GLGGJT: 1000000, //公共汽车意外身故及伤残保障
      JCSJGS: 500000 //私家车和公司班车意外身故及伤残保障
    }
  }
];
obj.columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '姓名',
    dataIndex: 'name'
  },
  {
    title: '证件类型',
    dataIndex: 'idType',
    key: 'idType',
    scopedSlots: { customRender: 'idType' }
  },
  {
    title: '证件号码',
    dataIndex: 'idNumber'
  },
  {
    title: '出生日期',
    dataIndex: 'birthDate'
  },
  {
    title: '性别',
    dataIndex: 'gender',
    key: 'gender',
    scopedSlots: { customRender: 'gender' }
  },
  {
    title: '职业代码',
    dataIndex: 'occupationCode'
  },
  {
    title: '职业名称',
    dataIndex: 'occupationName'
  },
  {
    title: '职业类别',
    dataIndex: 'occulevel',
    scopedSlots: { customRender: 'occulevel' }
  }
];
export default { ...obj };
